import { Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import PickUp from "./pages/PickUp";
import User from "./pages/User";

import DockerEntry from "./pages/DockerEntry";
import { ProtectedRoute } from "./utils/helper";
import PageNotFound from "./pages/PageNotFound";
import Manifestation from "./pages/Manifestation";
import DocketList from "./pages/DocketList";
import TripSheet from "./pages/TripSheet";
import ManifestList from "./pages/ManifestList";
import ManifestIn from "./pages/ManifestIn";
import TripSheetList from "./pages/TripSheetList";
import TripsheetIn from "./pages/TripsheetIn";
import Profile from "./pages/Profile";
import OfferLetterPage from "./pages/OfferLetter";
import PaySlip from "./pages/PaySlip";
import Home from "./pages/landing/Home";
import CreateBranch from "./pages/CreateBranch";
import PodUpload from "./pages/PodUpload";
import StuckDockets from "./pages/StuckDockets";

const ComponentsRoutes = () => {
  return (
    <Routes>
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allowedRoles={["MANAGER", "EMPLOYEE"]}>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/pickup"
        element={
          <ProtectedRoute>
            <PickUp />
          </ProtectedRoute>
        }
      />

      <Route
        path="/users"
        element={
          <ProtectedRoute allowedRoles={["MANAGER"]}>
            <User />
          </ProtectedRoute>
        }
      />
      <Route path="/admin-login" element={<Login />} />
      <Route path="/" element={<Home />} />
      <Route path="*" element={<PageNotFound />} />
      <Route
        path="/docket-entry"
        element={
          <ProtectedRoute>
            <DockerEntry />
          </ProtectedRoute>
        }
      />
      <Route
        path="manifest"
        element={
          <ProtectedRoute>
            <Manifestation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/docket-list"
        element={
          <ProtectedRoute>
            <DocketList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/manifest-list"
        element={
          <ProtectedRoute>
            <ManifestList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pod-upload"
        element={
          <ProtectedRoute>
            <PodUpload />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stuck-dockets"
        element={
          <ProtectedRoute>
            <StuckDockets />
          </ProtectedRoute>
        }
      />
      <Route
        path="/manifest-in"
        element={
          <ProtectedRoute>
            <ManifestIn />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tripsheet"
        element={
          <ProtectedRoute>
            <TripSheet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tripsheet-list"
        element={
          <ProtectedRoute>
            <TripSheetList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tripsheet-in"
        element={
          <ProtectedRoute>
            <TripsheetIn />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/offer-letter"
        element={
          <ProtectedRoute>
            <OfferLetterPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pay-slip"
        element={
          <ProtectedRoute>
            <PaySlip />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-branch"
        element={
          <ProtectedRoute allowedRoles={["MANAGER"]}>
            <CreateBranch />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default ComponentsRoutes;
